'use strict';

var $ = require('jquery');
var _ = require('lodash');
var GridTooltipService = function GridTooltipService($q, $rootScope, tooltipDataService) {
  var LAST_X = 0;
  var LAST_Y = 0;
  function triggerShowTooltip(rect, pageX, pageY, cellData, wholeGridData, gridId) {
    $rootScope.$broadcast('grid-custom-tooltip-' + gridId + ':hide');
    var tooltipData = tooltipDataService.getTooltipData(cellData, wholeGridData);
    if (tooltipData) {
      $q.resolve(tooltipData.htmlContent).then(function (value) {
        tooltipData.htmlContent = value;
        initializePositionAndBroadcastShowEvent(tooltipData, rect, pageX, pageY, gridId);
      });
    }
    LAST_X = rect.left;
    LAST_Y = rect.top;
  }
  function initializePositionAndBroadcastShowEvent(tooltipData, rect, pageX, pageY, gridId) {
    var offsetX = rect.left;
    var offsetY = rect.top;
    if (!_.get(tooltipData, 'noOffset')) {
      offsetX += $(window).scrollLeft();
      offsetY += $(window).scrollTop();
    }
    tooltipData.targetPosition = {
      height: rect.height,
      mouse: {
        pageX: pageX,
        pageY: pageY
      },
      offset: {
        left: offsetX,
        top: offsetY
      },
      width: rect.width
    };
    $rootScope.$broadcast('grid-custom-tooltip-' + gridId + ':show', tooltipData);
  }
  function triggerHideTooltip(gridId) {
    LAST_X = 0;
    LAST_Y = 0;
    $rootScope.$broadcast('grid-custom-tooltip-' + gridId + ':hide');
  }
  function getPreviousCellValue(cellData, wholeGridData, dataBeforeRefresh) {
    var entryKey = wholeGridData[cellData.row].entryKey;
    return _.get(dataBeforeRefresh, [entryKey, cellData.column]);
  }
  function hasValueChanged(previousCellValue, cellValue) {
    return (previousCellValue || previousCellValue === 0) && previousCellValue !== parseFloat(cellValue);
  }
  function isOnPreview(cellElement) {
    return cellElement.classList && (cellElement.classList.contains('rm-jqx-grid-cell-trend-up-preview') || cellElement.classList.contains('rm-jqx-grid-cell-trend-down-preview'));
  }
  function addCellTooltipWithPreviousValue(cellData, previousCellValue) {
    cellData.tooltip = 'refreshed-data-tooltip';
    cellData.valueBeforeRefresh = previousCellValue;
  }
  function checkCellDataChangedOnRefresh(cellData, wholeGridData, dataBeforeRefresh, refreshCellNames) {
    if (cellData && dataBeforeRefresh && !cellData.tooltip && refreshCellNames[cellData.column]) {
      var previousCellValue = getPreviousCellValue(cellData, wholeGridData, dataBeforeRefresh);
      if (hasValueChanged(previousCellValue, cellData.value)) {
        addCellTooltipWithPreviousValue(cellData, previousCellValue);
      }
    }
  }
  function tooltipTrigger(cellElement, pageX, pageY, cellData, wholeGridData, gridId, dataBeforeRefresh, refreshCellNames) {
    checkCellDataChangedOnRefresh(cellData, wholeGridData, dataBeforeRefresh, refreshCellNames);
    if (arguments.length && cellData && cellData.tooltip && !isOnPreview(cellElement)) {
      var rect = cellElement.getBoundingClientRect();
      if (LAST_X !== rect.left || LAST_Y !== rect.top) {
        triggerShowTooltip(rect, pageX, pageY, cellData, wholeGridData, gridId);
      }
    } else if (arguments.length === 0 || cellData && cellData.tooltip === null || cellData === undefined || isOnPreview(cellElement)) {
      triggerHideTooltip(gridId);
    }
  }
  var throttledTooltipTrigger = _.throttle(tooltipTrigger, 400);
  return {
    tooltipTrigger: throttledTooltipTrigger
  };
};
GridTooltipService.$inject = ['$q', '$rootScope', 'GridTooltipDataService'];
module.exports = GridTooltipService;